import { useState, useRef, useEffect } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Card, Form, Modal, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { ProfileOutlined, DeleteOutlined, PlusOutlined, MergeCellsOutlined } from '@ant-design/icons';
import { Box, Grid, Typography } from '@mui/material';
import TabBatchPCEMF from './TabBatchPCEMF';
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';


import React from 'react';


const PlanCpBatch = () => {

    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("");
    const [Idbutton, setIdbutton] = useState(false);
    const [activeTab, setActiveTab] = useState('1');
    const [batchSaveVisible, setBatchSaveVisible] = useState(false);
    const [batchSaveAction, setBatchSaveAction] = useState<'ECRASER' | 'MANQUANTS' | 'FUSIONNER'>('MANQUANTS');
    const tabBatchRef = useRef<any>(null);
    const [planCpList, setPlanCpList] = useState<{ Code: string; Libelle: string }[]>([]);
    const [planCpTree, setPlanCpTree] = useState<DataNode[]>([]);
    const [selectedParent, setSelectedParent] = useState<string>('');
    const [lastDigit, setLastDigit] = useState<string>('');
    const [addCodeError, setAddCodeError] = useState<string | null>(null);
    const [codeGenVisible, setCodeGenVisible] = useState(false);
    const [treeSearch, setTreeSearch] = useState<string>('');
    const [filteredTree, setFilteredTree] = useState<DataNode[]>([]);
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);

    const [Activetabs, SetActivetabs] = useState(false);

    const buildPlanCpTree = (list: { Code: string; Libelle: string }[]): DataNode[] => {
        const map: Record<string, DataNode> = {};
        list.forEach(item => {
            map[item.Code] = { title: `${item.Code} - ${item.Libelle}`, key: item.Code, children: [] };
        });
        const roots: DataNode[] = [];
        list.forEach(item => {
            const code = item.Code;
            let parentCode = '';
            for (let i = 1; i < code.length; i++) {
                const prefix = code.slice(0, -i);
                if (map[prefix]) { parentCode = prefix; break; }
            }
            if (parentCode) {
                map[parentCode].children!.push(map[code]);
            } else {
                roots.push(map[code]);
            }
        });
        const clean = (node: DataNode) => {
            if (node.children && node.children.length === 0) { delete node.children; }
            else if (node.children) { node.children.forEach(clean); }
        };
        roots.forEach(clean);
        return roots;
    };

    const loadPlanCpList = async () => {
        try {
            const body = { CodeAgence: '', Table: 'PLANCP', Colonne1: 'IDPLAN', Colonne2: 'LIBELL', Colagence: '101', Init: '', choix: 22 };
            const res = await axios.get(Data.ApiUrl.AnySearch, {
                headers: {
                    Authorization: authHeader(),
                    'Content-Type': 'application/json',
                    'CypherSearch': Crypter.encrypt(JSON.stringify(body))
                }
            });
            const raw = JSON.parse(Crypter.decrypt(res.data));
            const value = raw.Value ?? raw;
            if (value.StatutCode === 200) {
                const rows = value.Result.Table || [];
                const list = rows.map((data: any) => ({
                    Code: data.IDPLAN?.toString() ?? Object.values(data)[0]?.toString() ?? '',
                    Libelle: data.LIBELL?.toString() ?? Object.values(data)[1]?.toString() ?? ''
                })).filter((x: any) => x.Code);
                setPlanCpList(list);
                setPlanCpTree(buildPlanCpTree(list));
            }
        } catch (ex: any) { console.log(ex); }
    };

    useEffect(() => {
        loadPlanCpList();
    }, []);

    useEffect(() => {
        if (!treeSearch) {
            setFilteredTree(planCpTree);
            setExpandedKeys([]);
            return;
        }
        const search = treeSearch.toLowerCase();
        const codeSet = new Set(planCpList.map(p => p.Code));
        const included = new Set<string>();
        const addParents = (code: string) => {
            included.add(code);
            for (let i = 1; i < code.length; i++) {
                const prefix = code.slice(0, -i);
                if (codeSet.has(prefix)) { addParents(prefix); break; }
            }
        };
        planCpList.forEach(p => {
            if (p.Code.toLowerCase().includes(search) || p.Libelle.toLowerCase().includes(search)) {
                addParents(p.Code);
            }
        });
        const filtered = planCpList.filter(p => included.has(p.Code));
        setFilteredTree(buildPlanCpTree(filtered));
        setExpandedKeys(filtered.map(p => p.Code));
    }, [treeSearch, planCpList, planCpTree]);


    // GESTION DES ITEMS
    const items: TabsProps['items'] = [

        {
            key: '3',
            label: (
                <span id='x3'>
                    <ProfileOutlined />
                    Création Batch via PCEMF
                </span>
            ),
            children: <Form><TabBatchPCEMF ref={tabBatchRef} /></Form>,
        }
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex"  style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add'  onClick={() => { setBatchSaveVisible(true) }} type="ghost" htmlType="button" block>
                                    Enreg. le Batch
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>

                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>


                        </div>
                    </div>
                </Form>

                <Modal
                    title="Choix de l'action d'enregistrement"
                    open={batchSaveVisible}
                    onCancel={() => setBatchSaveVisible(false)}
                    onOk={() => {
                        if (tabBatchRef.current) {
                            tabBatchRef.current.saveBatch(batchSaveAction);
                        }
                        setBatchSaveVisible(false);
                    }}
                    okText='Confirmer'
                    cancelText='Annuler'
                    width={650}
                >
                    <Box style={{ padding: 12 }}>
                        <Typography variant='body2' color='text.secondary' style={{ display: 'block', marginBottom: 16 }}>
                            Sélectionnez la stratégie à appliquer au batch de plans comptables.
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Card
                                    hoverable
                                    size='small'
                                    onClick={() => setBatchSaveAction('ECRASER')}
                                    style={{
                                        borderColor: batchSaveAction === 'ECRASER' ? '#116599' : undefined,
                                        backgroundColor: batchSaveAction === 'ECRASER' ? '#edf5fa' : undefined,
                                        height: '100%'
                                    }}
                                >
                                    <DeleteOutlined style={{ fontSize: 28, color: '#116599' }} />
                                    <Typography style={{ color: '#0d4a70', display: 'block', marginTop: 8, fontWeight: 'bold' }}>
                                        ÉCRASER
                                    </Typography>
                                    <Typography variant='body2' color='text.secondary' style={{ fontSize: 12 }}>
                                        Supprime les plans existants et les remplace par les PCEMF importés.
                                    </Typography>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Card
                                    hoverable
                                    size='small'
                                    onClick={() => setBatchSaveAction('MANQUANTS')}
                                    style={{
                                        borderColor: batchSaveAction === 'MANQUANTS' ? '#116599' : undefined,
                                        backgroundColor: batchSaveAction === 'MANQUANTS' ? '#edf5fa' : undefined,
                                        height: '100%'
                                    }}
                                >
                                    <PlusOutlined style={{ fontSize: 28, color: '#116599' }} />
                                    <Typography style={{ color: '#0d4a70', display: 'block', marginTop: 8, fontWeight: 'bold' }}>
                                        MANQUANTS
                                    </Typography>
                                    <Typography variant='body2' color='text.secondary' style={{ fontSize: 12 }}>
                                        Crée uniquement les plans comptables qui n'existent pas encore.
                                    </Typography>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Card
                                    hoverable
                                    size='small'
                                    onClick={() => setBatchSaveAction('FUSIONNER')}
                                    style={{
                                        borderColor: batchSaveAction === 'FUSIONNER' ? '#116599' : undefined,
                                        backgroundColor: batchSaveAction === 'FUSIONNER' ? '#edf5fa' : undefined,
                                        height: '100%'
                                    }}
                                >
                                    <MergeCellsOutlined style={{ fontSize: 28, color: '#116599' }} />
                                    <Typography style={{ color: '#0d4a70', display: 'block', marginTop: 8, fontWeight: 'bold' }}>
                                        FUSIONNER
                                    </Typography>
                                    <Typography variant='body2' color='text.secondary' style={{ fontSize: 12 }}>
                                        Met à jour les plans existants et ajoute les nouveaux PCEMF.
                                    </Typography>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            </Spin>
        </div>
    );


}

export default PlanCpBatch; 